import { Injectable } from '@angular/core';
import { AlertController } from '@ionic/angular';

/**
 * Alert Service - Centralized AlertController management
 */
@Injectable({
	providedIn: 'root',
})
export class AlertService {
	/**
	 * Alert Service Constructor
	 * @param alertController - Ionic AlertController
	 */
	constructor(private alertController: AlertController) {}

	/**
	 * Show AlertController with two buttons (primary action + cancel)
	 * @param header - Alert title
	 * @param message - Alert message
	 * @param primaryButtonText - Text for primary action button (e.g., "Open", "Download")
	 * @param primaryButtonHandler - Handler function for primary button
	 * @param cancelButtonText - Text for cancel button (default: "Close")
	 */
	async showTwoButtonAlert(
		header: string,
		message: string,
		primaryButtonText: string,
		primaryButtonHandler: () => Promise<void> | void,
		cancelButtonText: string = 'Close'
	): Promise<void> {
		const alert = await this.alertController.create({
			header: header,
			message: message,
			buttons: [
				{
					text: cancelButtonText,
					role: 'cancel',
				},
				{
					text: primaryButtonText,
					handler: primaryButtonHandler,
				},
			],
		});

		await alert.present();
	}
}
